
import { Investor, Contact } from "@/types/investor";

/**
 * Calculates a domain from an email address
 */
export const extractDomain = (email: string): string => {
  if (!email || !email.includes("@")) return "";
  return email.split("@")[1];
};

/**
 * Matches contacts to investors based on fund name, email domains and company names
 */
export const matchContactsToInvestors = (
  investors: Investor[],
  contacts: Contact[]
): Investor[] => {
  return investors.map(investor => {
    // Find all contacts that might belong to this investor
    const matchedContacts = contacts.filter(contact => {
      // Direct Fund Name match (primary matching method)
      if (contact.firmName.toLowerCase() === investor.firm.toLowerCase()) {
        return true;
      }
      
      // Check for domain match if contact has email
      if (contact.email) {
        const domain = extractDomain(contact.email);
        // Some companies have different domains for their website and email
        // This is a simple heuristic that could be improved
        if (domain && 
            (investor.website?.includes(domain) || 
             domain.includes(investor.firm.toLowerCase().replace(/\s+/g, "")))) {
          return true;
        }
      }
      
      return false;
    });
    
    // Add contact count to investor object
    return {
      ...investor,
      contactCount: matchedContacts.length,
      matchedContactIds: matchedContacts.map(c => c.id)
    };
  });
};
